import { FunctionalComponent, h } from '@stencil/core';
import get from 'lodash/get'
import { AppLink, AppAd } from '.'

interface AppNavProducts {
    data: any
}


export const AppNavProducts: FunctionalComponent<AppNavProducts> = ({ data }) => {

    if (!data) return;

    const list1 = get(data, 'List1') || [];
    const list2 = get(data, 'List2') || [];
    const list3 = get(data, 'List3') || [];

    return (
        <div class="uk-navbar-dropdown uk-width-1-1 uk-padding ">
            <div class="uk-nav uk-navbar-dropdown-nav" >
                <div class="" uk-grid>
                    <div class="uk-width-1-1 uk-width-1-3@l">
                        <ul class="uk-nav">
                            <li class="uk-heading-small wsio-gold uk-margin-small-bottom">{data.Label1}</li>
                            <li class="uk-nav-divider"></li>
                            <div class="uk-column-1-2 uk-column-1-1@l uk-nav"> 
                            {
                                list1.map((Link, i, a) => {
                                    let hyphenGroup = false;
                                    if (Link && Link.Label && Link.Label.includes(' - ') && i > 0) {
                                        const prior = a[i - 1].Label.split('-')[0];
                                        const current = Link.Label.split('-')[0];
                                        hyphenGroup = prior == current;
                                    }
                                    return <li>{(get(Link, 'Label') || get(Link, 'Icon')) ? <AppLink className='uk-navbar-dropdown-close wsio-nav-link' data={Link} hyphenGroup={hyphenGroup} /> : <div class="uk-margin-top"></div>}</li>
                                })
                            }
                            </div>
                        </ul>
                    </div>
                    <div class="uk-width-1-2 uk-width-1-3@l">
                        <ul class="uk-nav">
                            <li class="uk-heading-small wsio-gold uk-margin-small-bottom">{data.Label2}</li>
                            <li class="uk-nav-divider"></li>
                            {
                                list2.map((Link, i, a) => {
                                    let hyphenGroup = false;
                                    if (Link.Label.includes(' - ') && i > 0) {
                                        const prior = a[i - 1].Label.split('-')[0];
                                        const current = Link.Label.split('-')[0];
                                        hyphenGroup = prior == current;
                                    }
                                    return <li><AppLink className='uk-navbar-dropdown-close wsio-nav-link  ' data={Link} hyphenGroup={hyphenGroup} /></li>
                                })
                            }
                        </ul>
                    </div>
                    <div class="uk-width-1-2 uk-width-1-3@l">
                        <ul class="uk-nav">
                            <li class="uk-heading-small wsio-gold uk-margin-small-bottom">{data.Label3}</li>
                            <li class="uk-nav-divider"></li>
                            {
                                list3.map((Link, i, a) => {
                                    let hyphenGroup = false;
                                    if (Link.Label.includes(' - ') && i > 0) {
                                        const prior = a[i - 1].Label.split('-')[0];
                                        const current = Link.Label.split('-')[0];
                                        hyphenGroup = prior == current;
                                    }
                                    return <li><AppLink className='uk-navbar-dropdown-close wsio-nav-link  ' data={Link} hyphenGroup={hyphenGroup} /></li>
                                })
                            }
                        </ul>
                    </div>
                    <div hidden={data.CTA} class="uk-width-1-1 uk-margin-medium-top"></div>
                    <div hidden={!data.CTA} class="uk-width-1-1 uk-margin-medium-top">
                        {data.CTA && <AppAd Title={get(data, 'CTA.Title')} Description={get(data, 'CTA.Description')} Media={get(data, 'CTA.Media')} Link={get(data, 'CTA.Link')} />}
                    </div>
                </div>
            </div>
        </div>
    )
};
